// extracted by mini-css-extract-plugin
export default {"Support":"Support_Support__8y2l5","Legal":"Support_Legal__MKHmr","TermsOfUse":"Support_TermsOfUse__-wWN5"};